const TIME_PATTERN = /^(\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?\s*(am|a|pm|p)?$/i;

const pad = (n: number) => (n < 10 ? `0${n}` : String(n));

export interface ParseTimeOptions {
  showSeconds?: boolean;
}

export const parseTimeString = (input: string, options: ParseTimeOptions = {}): string | null => {
  const trimmed = input.trim();
  if (!trimmed) return null;

  const match = TIME_PATTERN.exec(trimmed);
  if (!match) return null;

  const [, hourStr, minuteStr, secondStr, period] = match;
  const hourNum = Number(hourStr);
  const minuteNum = minuteStr === undefined ? 0 : Number(minuteStr);
  const secondNum = secondStr === undefined ? 0 : Number(secondStr);

  if (!Number.isFinite(hourNum) || !Number.isFinite(minuteNum) || !Number.isFinite(secondNum)) return null;
  if (minuteNum > 59 || secondNum > 59) return null;

  let hours = hourNum;
  if (period) {
    if (hours < 1 || hours > 12) return null;
    const isPM = period[0]?.toLowerCase() === "p";
    if (isPM) {
      hours = hours === 12 ? 12 : hours + 12;
    } else {
      hours = hours === 12 ? 0 : hours;
    }
  } else {
    if (hours > 23) return null;
  }

  const base = `${pad(hours)}:${pad(minuteNum)}`;
  return options.showSeconds ? `${base}:${pad(secondNum)}` : base;
};
